<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout v-if="!loading" row wrap>
            <v-flex md4><vue-plotly v-if="data" :white-mode="whiteMode" disable-responsive :data="data"
                                    :layout="layout" :options="{}"/></v-flex>
            <v-flex md4><vue-plotly v-if="data2" :white-mode="whiteMode" disable-responsive :data="data2"
                                    :layout="layout2" :options="{}"/></v-flex>
            <v-flex md4><vue-plotly v-if="data3" :white-mode="whiteMode" disable-responsive :data="data3"
                                    :layout="layout3" :options="{}"/></v-flex>

        </v-layout>
    </div>
</template>

<script>
    import {getNotification} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    import moment from "moment";
    export default {
        props: {
            title: {type: String, default: "Total Issue Detected"},
            title2: {type: String, default: "New Issues"},
            title3: {type: String, default: "Acknowledged Issues"},
            height: {type: Number, default: 240},
            dateRange: {type: Object, default: null},
            whiteMode:{type:Boolean, default: false},
        },
        components: {LoadingProgressBar,VuePlotly},
        computed: {},
        name: 'IssueSummaryWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                data:null,
                data2:null,
                data3:null,
                layout:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
                layout2:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
                layout3:{
                    "height": this.height,
                    "margin": {
                        "l": 50,
                        "r": 50,
                        "t": 50,
                        "pad": 1
                    }
                },
            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,200);
            },
            async getData(){
                if(this.dateRange){
                    this.loading=true
                    let notifResult = await getNotification({
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        date_range:[this.dateRange.start,moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59"],
                    })
                    let rangeFaults = notifResult.result.filter(x=>x.topic!=="anomaly"&&!x.title.toLowerCase().startsWith("anomaly"))
                    let newIssues=rangeFaults.filter(x=>x.start_date>=this.dateRange.start).length
                    let ackIssues=rangeFaults.filter(x=>x.acknowledged&&moment(x.last_ack_date).format('YYYY-MM-DD HH:mm:ss')>=moment(this.dateRange.start).format('YYYY-MM-DD HH:mm:ss')&&moment(x.last_ack_date).format('YYYY-MM-DD HH:mm:ss')<=moment(this.dateRange.end).format('YYYY-MM-DD')+" 23:59:59").length
                    this.data=[{
                        type:"indicator",
                        value:rangeFaults.length,
                        mode:"number",
                        title:{
                            text:this.title
                        }
                    }]
                    this.data2=[{
                        type:"indicator",
                        value:newIssues,
                        mode:"number",
                        title:{
                            text:this.title2
                        }
                    }]
                    this.data3=[{
                        type:"indicator",
                        value:ackIssues,
                        mode:"number",
                        title:{
                            text:this.title3
                        }
                    }]
                    this.loading=false
                }
            }
        },
    }
</script>
